package br.com.heyagenda.domain.usecase

import br.com.heyagenda.data.remote.FirestoreProfessionalDataSource
import br.com.heyagenda.data.remote.ProfessionalProfileDto

class GetProfessionalBySlugUseCase(
    private val professionalDataSource: FirestoreProfessionalDataSource
) {
    suspend operator fun invoke(slugOrUid: String): Pair<String, ProfessionalProfileDto>? {
        return professionalDataSource.fetchProfileBySlug(slugOrUid)
    }
}
